export const filter_config = ({ module_options }) => {
  return {
    title: 'Tenant filters',
    boolean_layout: 'flex', // 'grid' or 'flex'
    filters: [
      {
        label: 'Active',
        key: 'is_active',
        value: 'is_active',
        default: true,
        type: 'boolean'
      },
      {
        label: 'Has active subscription',
        key: 'metadata.has_active_subscription',
        value: 'metadata.has_active_subscription',
        type: 'boolean'
      },
      {
        label: 'Sent Campaign',
        key: 'metadata.has_sent_campaigns',
        value: 'metadata.has_sent_campaigns',
        type: 'boolean'
      },
      {
        label: 'Created workflows',
        key: 'metadata.has_created_workflows',
        value: 'metadata.has_created_workflows',
        type: 'boolean'
      },
      {
        label: 'Created neurons',
        key: 'metadata.has_created_neurons',
        value: 'metadata.has_created_neurons',
        type: 'boolean'
      },
      {
        label: 'Created contacts',
        key: 'metadata.has_created_contacts',
        value: 'metadata.has_created_contacts',
        type: 'boolean'
      },
      {
        label: 'Created audiences',
        key: 'metadata.has_created_audiences',
        value: 'metadata.has_created_audiences',
        type: 'boolean'
      },
      {
        label: 'Sent SMS message',
        key: 'metadata.has_sent_sms',
        value: 'metadata.has_sent_sms',
        type: 'boolean'
      },
      {
        label: 'Sent mobile push',
        key: 'metadata.has_sent_mobi_push',
        value: 'metadata.has_sent_mobi_push',
        type: 'boolean'
      },
      {
        label: 'Made email payments',
        key: 'metadata.has_made_email_payments',
        value: 'metadata.has_made_email_payments',
        type: 'boolean'
      },
      {
        label: 'Made SMS payments',
        key: 'metadata.has_made_sms_payments',
        value: 'metadata.has_made_sms_payments',
        type: 'boolean'
      },
      {
        label: 'Configured DNS',
        key: 'metadata.has_set_dns',
        value: 'metadata.has_set_dns',
        type: 'boolean'
      },
      {
        label: 'Active Subscritions',
        key: 'metadata.active_subscriptions',
        value: module_options,
        type: 'multichoice'
      },
      {
        value: 'metadata.average_monthly_spend',
        label: 'Monthly spend',
        key: 'metadata.average_monthly_spend',
        type: 'num_range'
      },
      {
        value: 'metadata.last_activity',
        label: 'Time of last activity',
        key: 'metadata.last_activity',
        type: 'range'
      },
      {
        value: 'created_on',
        label: 'Date created',
        key: 'created_on',
        type: 'range'
      }
    ]
  };
};
